document.addEventListener('DOMContentLoaded' , () =>{
    // tab    
    const tabModule = document.querySelectorAll('.js_tabModule');

    class tab {
        constructor(target) {
            this.target = target;
            this.tabBtnArray = Array.from(this.target.querySelectorAll('.js_btn'));
            this.tabConArray = Array.from(this.target.querySelectorAll(".js_tabContents"));
        }
    
        tabFn() {
            const _this = this;
            
            this.tabBtnArray.forEach(function(el,index){
                el.addEventListener("click" , function(){
                    _this.tabBtnArray.forEach(function(el){
                        el.classList.remove("on");
                    });

                    _this.tabBtnArray[index].classList.add("on");         

                    _this.tabConArray.forEach(function(el){
                        el.classList.remove("on");
                    })

                    _this.tabConArray[index].classList.add("on");
                })
            })
        }
    }    
    tabModule.forEach(el => {        
        new tab(el).tabFn();
    });

    // tabToggle    
    const tabToggleModule = document.querySelectorAll('.js_tabToggleModule');

    class tabToggle {
        constructor(target) {
            this.target = target;
            this.tabBtnArray = Array.from(this.target.querySelectorAll('.js_btn'));
            this.tabConArray = Array.from(this.target.querySelectorAll(".js_tabContents"));
            this.tabToggleBtn = this.target.querySelector('.js_toggle_btn');
        }
    
        tabToggleFn() {
            const _this = this;
            
            this.tabBtnArray.forEach(function(el,index){
                el.addEventListener("click" , function(){
                    _this.tabBtnArray.forEach(function(el){
                        el.classList.remove("on");
                    });

                    _this.tabBtnArray[index].classList.add("on");         

                    _this.tabConArray.forEach(function(el){
                        el.classList.remove("on");
                    })

                    _this.tabConArray[index].classList.add("on");
                })
            })
            this.tabToggleBtn.addEventListener('click', () => {
                _this.selectOpenFn();
            });
    
            this.tabBtnArray.forEach(el => {
                el.addEventListener('click', () => {
                    _this.selectedValueApplyFn(el);
                })
            });    
        }
    
        selectOpenFn(){
            this.tabToggleBtn.classList.toggle('active');
        }
    
        selectedValueApplyFn(txt){
            this.tabToggleBtn.classList.remove('active');
            this.tabToggleBtn.innerHTML = txt.innerHTML;
        }
    }    
    tabToggleModule.forEach(el => {        
        new tabToggle(el).tabToggleFn();
    });
});
